import { render } from "./Register.vue?vue&type=template&id=6d78a26e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=6d78a26e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6d78a26e"

export default script